import React from 'react'

const CTA = () => {
  return (
    <div className="cta">
      <a href="#ventures" className="btn btn-primary">Ventures</a>
      <a href="#projects" className="btn">Projects</a>
      <a href="#contact" className="btn">Contact</a>
    </div>
  )
}

export default CTA
